  $(document).ready(function(){
   $('.custom-product-highlight .resource-list.resource-list--grid').slick({
  dots: false,
  infinite: true,
  arrows: true, 
  speed: 300,
  autoplay: true,
  pauseOnHover: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 950, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 9999, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

ScrollReveal().reveal(".shop-by-categories-header,.section-resource-list__header,.custom-banner__heading,.custom-banner__subheading,.custom-banner__button,.custom_image_text .title,.text.heading_font,.custom_image_text .btn.v2,.lc-list li,.section-title,.faq-section .faq-item", {
  origin: "bottom",
  distance: "50px",
  duration: 1000
});



// More Scroll Reveal
ScrollReveal().reveal(".animation_item .resource-list__item,.popular-categories .category-card,.testimonial-left,.testimonial-stars,.testimonial-rating-text,.testimonial-text,.testimonial-author,.custom-content-column,.custom-image-column", {
    delay: 20,
  duration: 500,
  distance: "0px",
  opacity: 0,
  scale: 0.97,
  easing: "ease-in-out",
  reset: false,
  interval: 80
});


});

// Image Animation on Scroll
jQuery(document).ready(function ($2) {
  function isInViewport(elem) {
    const elementTop = $2(elem).offset().top,
      elementBottom = elementTop + $2(elem).outerHeight(),
      viewportTop = $2(window).scrollTop(),
      viewportBottom = viewportTop + $2(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  function checkAboutImageAnimation() {
    $2(".custom-product-highlight-image img,.img-wrap.small--hide img,.two-col-wrapper img,.custom-bannerr img").each(function () {
      if (isInViewport(this)) {
        $2(this).addClass("animate");
      } else {
        $2(this).removeClass("animate");
      }
    });
  }

  checkAboutImageAnimation();
  $2(window).on("scroll resize", checkAboutImageAnimation);
});



$(document).ready(function () {

  let lastWidth = $(window).width();

  function setupTabs() {

    const isMobile = $(window).width() <= 1024;

    /* =========================
       MOBILE ACCORDION
    ========================== */
    if (isMobile) {

      // Remove old events first
      $('.custom-product-tabs .mobile-tab-title').off('click');
      $('.custom-product-tabs .tab-titles li').off('click');

      // Hide desktop content
      $('.custom-product-tabs .tab-content').removeClass('active').hide();

      // Mobile click
      $('.custom-product-tabs .mobile-tab-title').on('click', function (e) {
        e.preventDefault();

        const $this = $(this);
        const $content = $this.next('.mobile-tab-content');

        if ($content.is(':visible')) {
          $content.stop(true, true).slideUp(300).removeClass('active');
          $this.removeClass('active');
        } else {
          $content.stop(true, true).slideDown(300).addClass('active');
          $this.addClass('active');
        }
      });

    }

    /* =========================
       DESKTOP TABS
    ========================== */
    else {

      // Remove mobile events
      $('.custom-product-tabs .mobile-tab-title').off('click');
      $('.custom-product-tabs .mobile-tab-content').removeClass('active').hide();

      $('.custom-product-tabs .tab-titles li').off('click').on('click', function () {

        const tabId = $(this).data('tab');

        $('.custom-product-tabs .tab-titles li').removeClass('active');
        $(this).addClass('active');

        $('.custom-product-tabs .tab-content').removeClass('active').hide();
        $('#' + tabId).show().addClass('active');
      });

      // Activate first tab only once
      if (!$('.custom-product-tabs .tab-titles li.active').length) {
        $('.custom-product-tabs .tab-titles li:first').addClass('active');
        $('.custom-product-tabs .tab-content:first').show().addClass('active');
      }
    }
  }

  /* Initial run */
  setupTabs();

  /* 🔥 IMPORTANT: Only re-run when breakpoint changes */
  $(window).on('resize', function () {

    const currentWidth = $(window).width();

    if (
      (lastWidth <= 1024 && currentWidth > 1024) ||
      (lastWidth > 1024 && currentWidth <= 1024)
    ) {
      setupTabs();
    }

    lastWidth = currentWidth;
  });

});


$('.menu-list .overflow-menu > .menu-list__list-item > .menu-list__link-title').hover(
  function () {
    $('body').addClass('menu-hover-active'); // hover 
  },
  function () {
    $('body').removeClass('menu-hover-active'); // hover 
  }
);
